// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/mechanical-engineering-assembly-part/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteMechanicalEngineeringAssemblyPartEN: PageEntry = {
  id: "example.produkte-montageteil-maschinenbau",
  locale: "en",
  slug: "produkte/mechanical-engineering-assembly-part",
  seo: {
    title: "Mechanical engineering assembly part | Dietz GmbH",
    description: "Blanks are cut, bent in prototype construction, riveting of the individual elements. As far as the function is concerned, a cylindrical body with a diameter of Ø38.7 +/-0.2 mm shou",
  },
  type: "post",
  h1: "Mechanical engineering assembly part",
  intro: "Blanks are cut, bent in prototype construction, riveting of the individual elements. As far as the function is concerned, a cylindrical body with a diameter of Ø38.7 +/-0.2 mm should be fixed between the spring plates and thus held in position.",
  blocks: [
    { kind: "image", src: "/images/live/dtz-montageteil-maschinenbau.jpg", alt: "Mechanical engineering assembly part", width: 1400, height: 1120 }
  ],
};
